// extracted by mini-css-extract-plugin
export default {"container":"placeholder-text_container__3a3Qs","pulse":"placeholder-text_pulse__14KNl"};